import React, { useEffect, useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../../common/UIGameActionButton/index.ts';
import { T, Tooltip } from '@colonist/ui';
import { CityImprovementTypes } from '@colonist/game-states';
import { UIGameCityImprovementTrackerSquare } from '../../../../common/UIGameCityImprovementTracker/UIGameCityImprovementTrackerSquare/UIGameCityImprovementTrackerSquare.tsx';
import { UIGameResourceCardsTooltipContent } from '../../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { useActionButtonCommonErrors } from '../../utils.ts';
import { EnumUtils } from '@colonist/utils';
import { useGameStore } from '../../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../../store/selectors/usePlayerValidators.ts';
import styles from '../UIGameActionButtonCityImprovements.module.scss';
import { useMechanicValidatorCityImprovements } from '../../../../store/selectors/useMechanicValidatorCityImprovements.ts';
export const UIGameActionButtonCityImprovementsItem = ({ cityImprovementType, className, hideTooltip, onDisabledChange })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const { getPlayerValidator } = usePlayerValidators();
    const playerValidator = getPlayerValidator(myColor);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const tooltipRef = useRef(null);
    const { sendConfirmCityUpgrade } = useGameStore((state)=>state.gameSendEvent);
    const cityImprovementValidator = useMechanicValidatorCityImprovements();
    const { actionStatus, costToUpgrade } = useMemo(()=>{
        if (!cityImprovementValidator) {
            return {
                actionStatus: {
                    canTakeAction: false
                }
            };
        }
        const costToUpgradeLocal = cityImprovementValidator.getCostForNextCityUpgradeForPlayerAndType(myColor, cityImprovementType);
        const canUpgradeCityActionStatus = cityImprovementValidator.canPlayerUpgradeCity(myColor, cityImprovementType);
        return {
            actionStatus: canUpgradeCityActionStatus,
            costToUpgrade: costToUpgradeLocal
        };
    }, [
        cityImprovementValidator,
        myColor,
        cityImprovementType
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !isAtMaxLevel ? !playerValidator.hasResourceCardsInHand(costToUpgrade) : false;
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const isAtMaxLevel = costToUpgrade == undefined;
    const disabled = hasCommonErrors || !actionStatus.canTakeAction;
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const improvementTypeKey = EnumUtils.getEnumKey(cityImprovementType, CityImprovementTypes);
    const translationText = {
        key: `strings:game.cards.progress.title.${improvementTypeKey}`
    };
    useEffect(()=>{
        onDisabledChange(disabled);
    }, [
        disabled
    ]);
    const onClick = ()=>{
        if (disabled) return;
        sendConfirmCityUpgrade(cityImprovementType);
    };
    return /*#__PURE__*/ React.createElement(Tooltip, {
        position: "bottom",
        disabled: hideTooltip,
        title: /*#__PURE__*/ React.createElement(T, {
            id: translationText
        })
    }, /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        iconClassName: styles.cityImprovementTrackerSquare,
        customIconComponent: /*#__PURE__*/ React.createElement(UIGameCityImprovementTrackerSquare, {
            cityImprovementType: cityImprovementType,
            active: !disabled
        }),
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: !isAtMaxLevel && !hideTooltip && /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: costToUpgrade,
            ref: tooltipRef
        }),
        onClick: onClick
    }));
};
